/**
 * Owner: Masa Bayu
 * File: platform.ts
 * Date:Time: 2026-09-16 19:17
 * Description: QXRead platform — T0–T9 EXIT GATED / PASSED / FROZEN (ecosystem seal).
 */
import { QXREAD_AUTHORITY_HIERARCHY, QXREAD_FOREIGN_AUTHORITIES, QXREAD_OWNED_AUTHORITIES, } from './authority';
import { assertCommerceInvariantsIntact, QXREAD_COMMERCE_RATE_CONTRACT, QXREAD_LEDGER_CONCEPTS, } from './commerce-boundary';
import { QXREAD_A11Y_BASELINE, QXREAD_BREAKPOINT_BANDS } from './design-tokens';
import { createQxreadPwaFoundation } from './pwa-foundation';
import { assertRewardWithdrawalInvariantsIntact, QXREAD_REWARD_BALANCE_STATES, QXREAD_REWARD_LEDGER_SOURCES, } from './reward-withdrawal';
import { QXREAD_SHELL_ROUTES } from './routing';
import { assertSecurityBaselineIntact } from './security-baseline';
import { createQxreadId } from './id';
export const QXREAD_FOUNDATION_VERSION = '0.1.0';
/** Certified foundation track. */
export const QXREAD_FOUNDATION_TRACK = 'T0';
export const QXREAD_FOUNDATION_TRACK_STATUS = 'PASSED';
/** Sole active implementation track (T0–T9 ecosystem seal complete). */
export const QXREAD_ACTIVE_TRACK = 'T9';
export const QXREAD_ACTIVE_TRACK_STATUS = 'PASSED';
/** @deprecated Prefer QXREAD_FOUNDATION_TRACK — kept for T0 shell meta compatibility. */
export const QXREAD_TRACK = QXREAD_FOUNDATION_TRACK;
/** @deprecated Prefer QXREAD_FOUNDATION_TRACK_STATUS. */
export const QXREAD_TRACK_STATUS = QXREAD_FOUNDATION_TRACK_STATUS;
export function createQxreadPlatformFoundation() {
    return Object.freeze({
        foundationId: createQxreadId('qxrdfdn'),
        version: QXREAD_FOUNDATION_VERSION,
        track: QXREAD_FOUNDATION_TRACK,
        trackStatus: QXREAD_FOUNDATION_TRACK_STATUS,
        activeTrack: QXREAD_ACTIVE_TRACK,
        activeTrackStatus: QXREAD_ACTIVE_TRACK_STATUS,
        authorityHierarchy: QXREAD_AUTHORITY_HIERARCHY,
        foreignAuthorities: QXREAD_FOREIGN_AUTHORITIES,
        ownedAuthorities: QXREAD_OWNED_AUTHORITIES,
        shellRoutes: QXREAD_SHELL_ROUTES,
        securityBaseline: assertSecurityBaselineIntact(),
        a11yBaseline: QXREAD_A11Y_BASELINE,
        breakpointBands: QXREAD_BREAKPOINT_BANDS,
        pwa: createQxreadPwaFoundation(),
        commerceBoundary: Object.freeze({
            invariants: assertCommerceInvariantsIntact(),
            rateContract: QXREAD_COMMERCE_RATE_CONTRACT,
            ledgerConcepts: QXREAD_LEDGER_CONCEPTS,
            settlementTrack: 'T3',
            rewardWithdrawal: Object.freeze({
                invariants: assertRewardWithdrawalInvariantsIntact(),
                balanceStates: QXREAD_REWARD_BALANCE_STATES,
                ledgerSources: QXREAD_REWARD_LEDGER_SOURCES,
                implementationTrack: 'T3',
                operationsTrack: 'T7',
            }),
        }),
        closedTracks: Object.freeze([]),
    });
}
//# sourceMappingURL=platform.js.map